import React from "react";
import CronSettings from "./Components/CronSettings";

const CronSettingsIndex: React.FC = () => {
    return <CronSettings />;
};

export default CronSettingsIndex;
